import * as React from "react";
import PropTypes from 'prop-types';

const SvgUrgencyPdpSold = props => {
  if (props.id !== "_svgurgencypdpsold") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="-5 -2 24 24" {...props}><path d="M12.366 9.368c-.183-2.386-1.294-3.882-2.275-5.201C9.184 2.945 8.4 1.89 8.4.334a.334.334 0 00-.527-.271C6.4 1.116 5.173 2.89 4.743 4.585c-.297 1.18-.337 2.505-.342 3.38-1.36-.29-1.668-2.323-1.67-2.345a.335.335 0 00-.477-.253c-.07.035-1.75.887-1.847 4.292A6.007 6.007 0 006.4 16h.018a6.007 6.007 0 005.982-6c0-.165-.034-.631-.034-.631zM6.4 15.333c-1.103 0-2-.956-2-2.13 0-.04 0-.08.003-.13.013-.496.107-.834.21-1.059.194.415.54.797 1.1.797a.333.333 0 00.334-.333c0-.475.01-1.022.128-1.516.105-.438.357-.905.675-1.278.141.485.418.877.687 1.26.386.549.785 1.115.855 2.082.004.057.008.115.008.176 0 1.175-.897 2.13-2 2.13z" fill="#FFF" /></svg>;
};

SvgUrgencyPdpSold.displayName = "_svgurgencypdpsold";
SvgUrgencyPdpSold.propTypes = {
  id: PropTypes.string
};
SvgUrgencyPdpSold.defaultProps = {
  id: ''
};
export default SvgUrgencyPdpSold;